module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j7BtR"))).then(() => parcelRequire('5erN3'));